import { c as _c } from "react/compiler-runtime";
import { APIList } from '../../../../../../../typings/API.interface';
import { OutpostAttempt } from '../../../../../../../typings/outpost';
import { capitalizeFirstLetter } from '../../../../utils';
import Badge from '../../../common/base/Badge';
import Text from '../../../common/base/Text';
import DisplayDate from '../../../common/DisplayDate';
import Table from '../../../common/Table/Table';
const PreviousAttemptsList: React.FC<{
  attempts?: APIList<OutpostAttempt>;
  selected_attempt_id?: string;
  onAttemptSelected: (attempt_id: string) => void;
}> = t0 => {
  const $ = _c(12);
  const {
    attempts,
    selected_attempt_id,
    onAttemptSelected
  } = t0;
  let t1;
  if ($[0] !== attempts?.models || $[1] !== selected_attempt_id) {
    t1 = attempts?.models.map(attempt => ({
      id: attempt.id,
      selected: selected_attempt_id === attempt.id,
      highlighted: selected_attempt_id === attempt.id,
      fields: [<Text key={`${attempt.id}-number`} mono={true} size="s">#{attempt.attempt_number}</Text>, <DisplayDate key={`${attempt.id}-time`} date={attempt.time} show_timezone={false} />, <Badge key={`${attempt.id}-status`} subtle={true} success={attempt.status === "success"} danger={attempt.status === "failed"}>{capitalizeFirstLetter(attempt.status)}</Badge>]
    })) || [];
    $[0] = attempts?.models;
    $[1] = selected_attempt_id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rows = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["Attempt", "Time", "Status"];
    t3 = [{
      min: 100,
      max: 100
    }, {
      min: 152,
      max: 152
    }, {
      min: 120,
      max: 120
    }];
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const t4 = rows as any;
  const t5 = !attempts;
  let t6;
  if ($[5] !== onAttemptSelected) {
    t6 = attempt_id => attempt_id && onAttemptSelected(attempt_id);
    $[5] = onAttemptSelected;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = attempts?.models.length;
  let t8;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <Table fill={true} footer={false} headers={t2} widths={t3} rows={t4} loading={t5} onRowSelected={t6} current_count={t7} />;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default PreviousAttemptsList;